// extracted by mini-css-extract-plugin
module.exports = {"svgLogo":"styles__svgLogo___2kRM6","revealSvg":"styles__revealSvg___32qoo"};